import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { UserSlice, UserState } from "@/store/slices/types/userSlice";
// @ts-expect-error: ignoring as it is existing js file
import { userSelector } from "@/store/slices/userSlice";
import { ROUTES } from "@/constants";

// This is nested wrapper
export default function AdminAuthWrapper() {
  const { isAdmin } = useSelector<UserSlice, UserState>(userSelector);

  const isAdminUser = isAdmin || false;

  if (!isAdminUser) {
    return <Navigate to={ROUTES.NOT_FOUND} />;
  }

  return <Outlet />;
}
